import { Navigate } from "react-router-dom";
import { useRoleBasedAccess } from "@/hooks/use-role-based-access";

export const SuperuserGate = ({ children }: { children: React.ReactNode }) => {
  const { isSystemAdmin, isLoading } = useRoleBasedAccess();
  if (isLoading) return null;
  if (!isSystemAdmin) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
};
